export enum TrackingEvent {
  AddClause = `Add clause`,
  AddLiteral = `Add literal`,
  AddPropertyFilter = `Add property filter`,
  ChangeConditionType = `Change condition type`,
  ClickAddFilter = `Click add filter`,
  GroupLiterals = `Group literals`,
  MoveLiteral = `Move literal`,
  MultipartFilterSelect = `Multipart Filter Select`,
  RemoveClause = `Remove clause`,
  RemoveLiteral = `Remove literal`,
  RemovePropertyFilter = `Remove property filter`,
  ResetCohort = `Reset cohort`,
  RestoreLiteral = `Restore literal`,
  SelectCountType = `Select count type`,
  SelectCustomDateRange = `Select custom date range`,
  SelectCohort = `Select cohort`,
  SelectEvent = `Select event`,
  SelectFrequencyOperator = `Select frequency operator`,
  SelectInitialClauseOperator = `Select initial clause operator`,
  SelectJoinClauseOperator = `Select join clause operator`,
  ToggleClauseNegated = `Toggle clause negated`,
  TogglePropertyFilterOperator = `Toggle property filter operator`,
  UngroupLiterals = `Ungroup literals`,
  UpdateCohort = `Update cohort`,
  UpdateFrequency = `Update frequency`,
  UpdatePeopleClause = `Update people clause`,
  UpdatePropertyFilter = `Update property filter`,
}

export const EVENTS_TO_TRACK_IN_MIXPANEL_PROD: Set<TrackingEvent> = new Set([
  TrackingEvent.AddClause,
  TrackingEvent.AddLiteral,
  TrackingEvent.AddPropertyFilter,
  TrackingEvent.ChangeConditionType,
  TrackingEvent.MultipartFilterSelect,
  TrackingEvent.RemoveLiteral,
  TrackingEvent.ResetCohort,
  TrackingEvent.SelectCohort,
  TrackingEvent.SelectInitialClauseOperator,
  TrackingEvent.SelectJoinClauseOperator,
  TrackingEvent.UpdateCohort,
]);

export enum TrackingEventPropertyName {
  UserCount = `cohort user count`,
}
